import React from 'react'
import cx from 'classnames'

import Text from 'components/_new/typography/Text/Text'
import { Box, Row } from 'components/_new/layout'

import s from './Ribbon.scss'


export const offsets = [ 8, 16 ]

type RibbonProps = {
  className?: string
  text: ReactIntlMessage | string
  offsetTop?: typeof offsets[number]
}

const Ribbon: React.FunctionComponent<RibbonProps> = ({ className, text, offsetTop }) => {
  const rootClassName = cx(s.container, className, {
    [s[`offset-${offsetTop}`]]: offsetTop,
  })

  return (
    <Box className={rootClassName} pb={12} ph={16}>
      <Row
        className={s.ribbon}
        justify="center"
      >
        <Text
          message={text}
          size="16-24"
          color="white"
          align="center"
          semibold
          uppercase
          letterSpacing
        />
      </Row>
    </Box>
  )
}


export default Ribbon
